import type { UserConfig } from 'i18next-parser'
import baseConfig, { StaticSharedI18nResources } from '../shared/i18next-parser.config'
import deTranslation from './src/i18n/resources/de/translation.json'
import devTranslation from './src/i18n/resources/dev/translation.json'
import enTranslation from './src/i18n/resources/en/translation.json'

export const I18NConfig = {
  resources: {
    en: {
      shared: StaticSharedI18nResources.resources.en,
      translation: enTranslation,
    },
    dev: {
      shared: StaticSharedI18nResources.resources.dev,
      translation: devTranslation,
    },
    de: {
      shared: StaticSharedI18nResources.resources.de,
      translation: deTranslation,
    },
  },
  namespace: ['translation' as const, StaticSharedI18nResources.namespace],
} as const

const config: UserConfig = {
  ...baseConfig,
  defaultNamespace: 'translation',
}

// biome-ignore lint/style/noDefaultExport: i18n parser expects a default export
export default config
